module.exports = __webpack_public_path__ + "img/ETAPAS.da0564fb.png";